module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseImage",
    class: ("BaseImage--" + _vm.size),
    style: ([
      _vm.size == 'aspect-ratio' && {
        paddingBottom: (((_vm.height / _vm.width) * 100) + "%"),
      } ])
  }, [_c('img', {
    directives: [{
      name: "lazyload",
      rawName: "v-lazyload"
    }],
    staticClass: "BaseImage-image u-posAbsoluteCenter",
    attrs: {
      "alt": _vm.alt,
      "data-src": _vm.src,
      "data-srcset": _vm.srcset,
      "decoding": "async"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e9a431e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseImage.vue
// module id = 170
// module chunks = 1